import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 2F091499-4472-423E-A0C5-8C96CDDE1ABF
 * name currency-ngn
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-ngn.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencyNgnIcon = createSvgIcon(<><path d="M4,9H6V3H8L11.42,9H16V3H18V9H20V11H18V13H20V15H18V21H16L12.57,15H8V21H6V15H4V13H6V11H4V9M8,9H9.13L8,7.03V9M8,11V13H11.42L10.28,11H8M16,17V15H14.85L16,17M12.56,11L13.71,13H16V11H12.56Z" /></>, 'CurrencyNgnIcon');
export default CurrencyNgnIcon